export const START_FINISH_TEST = 'display_start_finish';
